import { render, staticRenderFns } from "./UlsiinShalgaltBurtgeh.vue?vue&type=template&id=177663f0"
import script from "./UlsiinShalgaltBurtgeh.vue?vue&type=script&lang=js"
export * from "./UlsiinShalgaltBurtgeh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports